// 메뉴 이동 로그(CORE_MENU_ACCESS)용 공통 코드 규약.
// ⚠️ 이 { module, menu } 값은 웹·모바일이 "동일하게" 사용해야 통합 조회/집계가 됩니다.
//    (웹은 path 키로 조회, 모바일은 각 화면을 같은 module/menu 값에 매핑해서 API 로 전송)
// path(정확 매칭) → { module, menu }. 여기에 없는 경로(상세/팝업/동적)는 로그 대상 아님.

export const MENU_CODES = {
  // Remote (AR 원격지원)
  "/remote/dashboard": { module: "REMOTE", menu: "dashboard" },
  "/remote/history": { module: "REMOTE", menu: "history" },
  "/remote/settings": { module: "REMOTE", menu: "settings" },
  "/remote/members": { module: "REMOTE", menu: "members" },
  "/remote/zone": { module: "REMOTE", menu: "zone" },

  // History (기술지원 이력)
  "/history/orders": { module: "HISTORY", menu: "orders" },
  "/history/PastReqList": { module: "HISTORY", menu: "pastReqList" },
  "/history/SupportList": { module: "HISTORY", menu: "supportList" },

  // Check (XR 핫스팟 점검)
  "/check/dashboard": { module: "CHECK", menu: "dashboard" },
  "/check/index": { module: "CHECK", menu: "positionAdd" },
  "/check/positionAdd": { module: "CHECK", menu: "positionAdd" },
  "/check/positionSelect": { module: "CHECK", menu: "positionSelect" },
  "/check/pointAdd": { module: "CHECK", menu: "pointAdd" },
  "/check/pointSelect": { module: "CHECK", menu: "pointSelect" },
  "/check/checkResult": { module: "CHECK", menu: "checkResult" },
  "/check/checkResultReport": { module: "CHECK", menu: "checkResultReport" },

  // Admin (관리자)
  "/admin/users": { module: "ADMIN", menu: "users" },
  "/admin/permissions": { module: "ADMIN", menu: "permissions" },
  "/admin/logs": { module: "ADMIN", menu: "logs" },
  "/admin/backup": { module: "ADMIN", menu: "backup" },
  "/admin/billing": { module: "ADMIN", menu: "billing" },
  "/admin/security": { module: "ADMIN", menu: "security" },

  // Core (공용)
  "/account": { module: "CORE", menu: "account" },
};

// path → { module, menu } (없으면 null)
export function resolveMenuCode(path) {
  return MENU_CODES[path] || null;
}
